import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ResourceCard slots="link, image,text, buttons" width="33%" theme="lightest" isFooter className='useCaseCard  landingResourceCard' isCustomStories mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/assets/0b7e0c0c8e7a0c1daf38eea181b18214/Evisort.pdf"
      }}>{`Evisort.pdf`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "556px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "48.679245283018865%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/4098c5b27691373d45cdbc22431e2af4/dda86/6_CardImage_Logo_EVISORT.webp 265w", "/document-services/static/4098c5b27691373d45cdbc22431e2af4/010e6/6_CardImage_Logo_EVISORT.webp 530w", "/document-services/static/4098c5b27691373d45cdbc22431e2af4/b4d04/6_CardImage_Logo_EVISORT.webp 556w"],
            "sizes": "(max-width: 556px) 100vw, 556px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/4098c5b27691373d45cdbc22431e2af4/28773/6_CardImage_Logo_EVISORT.png 265w", "/document-services/static/4098c5b27691373d45cdbc22431e2af4/a0177/6_CardImage_Logo_EVISORT.png 530w", "/document-services/static/4098c5b27691373d45cdbc22431e2af4/68b51/6_CardImage_Logo_EVISORT.png 556w"],
            "sizes": "(max-width: 556px) 100vw, 556px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/4098c5b27691373d45cdbc22431e2af4/68b51/6_CardImage_Logo_EVISORT.png",
            "alt": "Waymark workflows with Adobe PDF Extract API.",
            "title": " ",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`See how Evisort uses Adobe PDF Extract API to bring visibility and intelligence to contracts.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/assets/0b7e0c0c8e7a0c1daf38eea181b18214/Evisort.pdf"
        }}>{`Read story`}</a></li>
    </ul>
    <ResourceCard slots="link, image, text, buttons" width="33%" theme="lightest" isFooter className='useCaseCard  landingResourceCard' isCustomStories mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/assets/274e980638128d62e8135428af6f3cb9/K2Nintex.pdf"
      }}>{`K2Nintex.pdf`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "556px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "48.679245283018865%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/ee85c3229c0e1700dc67cb4b9eedfb1d/dda86/6_CardImage_Logo_nintex.webp 265w", "/document-services/static/ee85c3229c0e1700dc67cb4b9eedfb1d/010e6/6_CardImage_Logo_nintex.webp 530w", "/document-services/static/ee85c3229c0e1700dc67cb4b9eedfb1d/b4d04/6_CardImage_Logo_nintex.webp 556w"],
            "sizes": "(max-width: 556px) 100vw, 556px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/ee85c3229c0e1700dc67cb4b9eedfb1d/28773/6_CardImage_Logo_nintex.png 265w", "/document-services/static/ee85c3229c0e1700dc67cb4b9eedfb1d/a0177/6_CardImage_Logo_nintex.png 530w", "/document-services/static/ee85c3229c0e1700dc67cb4b9eedfb1d/68b51/6_CardImage_Logo_nintex.png 556w"],
            "sizes": "(max-width: 556px) 100vw, 556px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/ee85c3229c0e1700dc67cb4b9eedfb1d/68b51/6_CardImage_Logo_nintex.png",
            "alt": "Adobe InDesign Share for Review built with PDF Embed API",
            "title": " ",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`See how Nintex transforms K2 Cloud workflows to automate employee access and remote work tracking.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/assets/274e980638128d62e8135428af6f3cb9/K2Nintex.pdf"
        }}>{`Read story`}</a></li>
    </ul>
    <ResourceCard slots="link, image, text, buttons" width="33%" theme="lightest" isFooter className='useCaseCard  hme-custom-header landingResourceCard' isCustomStories mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/assets/a70840fd5f99c8c352419e933715885e/Waymark-Story.pdf"
      }}>{`Waymark-Story.pdf`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "556px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "48.679245283018865%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/6ce063485b6ffd613d3570e08c0a7ebf/dda86/6_CardImage_Logo_Waymark.webp 265w", "/document-services/static/6ce063485b6ffd613d3570e08c0a7ebf/010e6/6_CardImage_Logo_Waymark.webp 530w", "/document-services/static/6ce063485b6ffd613d3570e08c0a7ebf/b4d04/6_CardImage_Logo_Waymark.webp 556w"],
            "sizes": "(max-width: 556px) 100vw, 556px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/6ce063485b6ffd613d3570e08c0a7ebf/28773/6_CardImage_Logo_Waymark.png 265w", "/document-services/static/6ce063485b6ffd613d3570e08c0a7ebf/a0177/6_CardImage_Logo_Waymark.png 530w", "/document-services/static/6ce063485b6ffd613d3570e08c0a7ebf/68b51/6_CardImage_Logo_Waymark.png 556w"],
            "sizes": "(max-width: 556px) 100vw, 556px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/6ce063485b6ffd613d3570e08c0a7ebf/68b51/6_CardImage_Logo_Waymark.png",
            "alt": "Cambridge Assessment digitizes test data with PDF Extract API",
            "title": " ",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`See how Waymark Tech enables rapid impact assessments and compliance workflows with Adobe PDF Extract API.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/assets/a70840fd5f99c8c352419e933715885e/Waymark-Story.pdf"
        }}>{`Read story`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      